import { memo } from 'react';
import { Badge, ButtonProps, Tooltip } from '@mantine/core';
import { Wifi, WifiOff } from 'lucide-react';
import { DeviceConnectionStatus } from '../../types';

interface ConnectionBadgeProps {
  status?: DeviceConnectionStatus;
  tooltipLabel?: string;
  size?: ButtonProps['size'];
}

export const ConnectionBadge = memo<ConnectionBadgeProps>(
  ({ status, tooltipLabel, size = 'xs' }) => {
    const isDisconnected = status === 'disconnected' || !status;
    const isReceivingData = status === 'receiving_data';
    const isConnectedNoData = status === 'connected_no_data';
    const isConnected = status === 'connected';
    const isKnownStatus =
      !status ||
      status === 'disconnected' ||
      status === 'receiving_data' ||
      status === 'connected_no_data' ||
      status === 'connected';

    if (!isKnownStatus) return null;

    const getBadgeColor = () => {
      if (isDisconnected) return 'red';
      if (isReceivingData) return 'teal';
      if (isConnectedNoData) return 'yellow';
      if (isConnected) return 'teal';
      return 'gray';
    };

    const getBadgeText = () => {
      if (isDisconnected) return 'Non Connesso';
      if (isReceivingData) return 'Connesso';
      if (isConnectedNoData) return 'Connesso - In Attesa';
      if (isConnected) return 'Connesso';
      return '';
    };

    const badge = (
      <Badge
        color={getBadgeColor()}
        variant='light'
        radius='sm'
        leftSection={
          isDisconnected ? <WifiOff size={14} /> : <Wifi size={14} />
        }
        size={size}
        style={{ cursor: tooltipLabel ? 'help' : 'default' }}
      >
        {getBadgeText()}
      </Badge>
    );

    if (tooltipLabel) {
      return (
        <Tooltip
          label={tooltipLabel}
          position='right'
          withArrow
          disabled={!tooltipLabel}
        >
          {badge}
        </Tooltip>
      );
    }

    return badge;
  }
);

ConnectionBadge.displayName = 'ConnectionBadge';
